module.exports = __webpack_public_path__ + "static/media/cookiesPolicy.ef36edbe.pdf";